import { PaymentMethod, PaymentMethodType } from 'types';

export interface GetAmountAndBalance<T> {
  formValues: T;
  saleTotal: number;
  creditProccessingFees: number;
}

export const calculateBalance = ({
  saleTotal,
  paymentMethods,
  creditProccessingFees,
}: {
  saleTotal: number;
  creditProccessingFees: number;
  paymentMethods: PaymentMethod[];
}) => {
  const paymentMethodsTotal = paymentMethods.reduce(
    (acc, item) => acc + +item.amount,
    0
  );

  return +(saleTotal - paymentMethodsTotal - creditProccessingFees).toFixed(2);
};

export const calculateChange = (paymentMethods: PaymentMethod[] = []) => {
  if (!paymentMethods.some((method) => method.receivedCashAmount)) {
    return 0;
  }

  const cashPayments = paymentMethods.filter(
    (method) => method.type === PaymentMethodType.Cash
  );

  const totalReceivedCashAmount = cashPayments.reduce(
    (acc, payment) => acc + (payment.receivedCashAmount ?? 0),
    0
  );

  const totalCashAmount = cashPayments.reduce(
    (acc, payment) => acc + +payment.amount,
    0
  );

  return Math.max(
    Number((totalReceivedCashAmount - totalCashAmount).toFixed(2)),
    0
  );
};

export const getAmountAndBalance = <T extends Record<string, any>>({
  saleTotal,
  formValues,
  creditProccessingFees,
}: GetAmountAndBalance<T>) => {
  const balance = calculateBalance({
    saleTotal,
    creditProccessingFees,
    paymentMethods: formValues.paymentMethods,
  });

  const hasSalesAndFullAmount = formValues?.commissions?.length && !balance;

  return { balance, hasSalesAndFullAmount };
};
